import decode from 'jwt-decode';
import Vue from 'vue';
import Vuex from 'vuex';

import router from '../router/index';
import { transformPermission } from '../utils/transformarPermisosUtil';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    token: null,
    usuario: null,
    rol: null,
    objPermisos: {},
    tokenRol: null,
    tokenAPI: null,
    colorFooter: null,
    logo: null,
    nombrePlataforma: null,
  },
  mutations: {
    setToken(state, token) {
      state.token = token;
    },
    setTokenRol(state, tokenRol) {
      state.tokenRol = tokenRol;
    },
    setUsuario(state, usuario) {
      state.usuario = usuario;
    },
    setRol(state, rol) {
      state.rol = rol;
    },
    setPermisos(state, objPermisos) {
      state.objPermisos = objPermisos;
    },
    setTokenAPI(state, tokenAPI) {
      state.tokenAPI = tokenAPI;
    },
    setColorFooter(state, colorFooter) {
      state.colorFooter = colorFooter;
    },
    setLogo(state, logo) {
      state.logo = logo;
    },
    setNombrePlataforma(state, nombrePlataforma) {
      state.nombrePlataforma = nombrePlataforma;
    },
  },
  getters: {
    getStatusPermission: state => permisoId => {
      return state.objPermisos?.[permisoId] === true;
    },
  },
  actions: {
    guardarTokenRol({ commit }, tokenRol) {
      commit('setTokenRol', tokenRol);
      const rol = decode(tokenRol);
      commit('setRol', rol);
      const permisos = rol?.roles?.permisos ?? [];
      commit('setPermisos', transformPermission(permisos));
      localStorage.setItem('tokenRol', tokenRol);
    },
    saveTokenAPI({ commit }, tokenAPI) {
      commit('setTokenAPI', tokenAPI);
      localStorage.setItem('tokenAPI', tokenAPI);
    },
    guardarToken({ commit }, token) {
      commit('setToken', token);
      commit('setUsuario', decode(token));
      localStorage.setItem('token', token);
    },
    autoLogin({ commit }) {
      const token = localStorage.getItem('token');
      if (token) {
        commit('setToken', token);
        commit('setUsuario', decode(token));
        router.push({
          name: 'Home',
        });
      }
    },
    autoTokenRol({ commit }) {
      const tokeRol = localStorage.getItem('tokenRol');
      if (tokeRol) {
        commit('setTokenRol', tokeRol);
        const rol = decode(tokeRol);
        commit('setRol', rol);
        const permisos = rol?.roles?.permisos ?? [];
        commit('setPermisos', transformPermission(permisos));
      }
    },
    autoTokenAPI({ commit }) {
      const tokenAPI = localStorage.getItem('tokenAPI');
      if (tokenAPI) {
        commit('setTokenAPI', tokenAPI);
      }
    },
    salir({ commit }) {
      commit('setToken', null);
      commit('setTokenRol', null);
      commit('setUsuario', null);
      commit('setRol', null);
      commit('setPermisos', {});
      commit('setTokenAPI', null);
      localStorage.removeItem('token');
      localStorage.removeItem('tokenRol');
      localStorage.removeItem('tokenAPI');
      router.push({
        name: 'Login',
      });
    },
  },
  modules: {},
});
